import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import axios from 'axios'
import router from './router/index'
import { store } from './store/index'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

import { faUserCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faUserCircle)

import { faCopy } from '@fortawesome/free-solid-svg-icons'
library.add(faCopy)

import { faPlus } from '@fortawesome/free-solid-svg-icons'
library.add(faPlus)

import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'
library.add(faSyncAlt)

import { faFileAlt } from '@fortawesome/free-solid-svg-icons'
library.add(faFileAlt)

import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faQuestionCircle)

import { faTruck } from '@fortawesome/free-solid-svg-icons'
library.add(faTruck)

import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
library.add(faFileInvoice)

import { faTruckMoving } from '@fortawesome/free-solid-svg-icons'
library.add(faTruckMoving)

import { faMonument } from '@fortawesome/free-solid-svg-icons'
library.add(faMonument)

import { faDoorOpen } from '@fortawesome/free-solid-svg-icons'
library.add(faDoorOpen)

import { faDoorClosed } from '@fortawesome/free-solid-svg-icons'
library.add(faDoorClosed)

import { faBarcode } from '@fortawesome/free-solid-svg-icons'
library.add(faBarcode)

import { faFileDownload } from '@fortawesome/free-solid-svg-icons'
library.add(faFileDownload)

import { faPaperclip } from '@fortawesome/free-solid-svg-icons'
library.add(faPaperclip)

import { faReply } from '@fortawesome/free-solid-svg-icons'
library.add(faReply)

import { faBox } from '@fortawesome/free-solid-svg-icons'
library.add(faBox)

import { faHashtag } from '@fortawesome/free-solid-svg-icons'
library.add(faHashtag)

import { faClock } from '@fortawesome/free-solid-svg-icons'
library.add(faClock)

import { faUser } from '@fortawesome/free-solid-svg-icons'
library.add(faUser)

import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faInfoCircle)

import { faDownload } from '@fortawesome/free-solid-svg-icons'
library.add(faDownload)

import { faPrint } from '@fortawesome/free-solid-svg-icons'
library.add(faPrint)

import { faFileArchive } from '@fortawesome/free-solid-svg-icons'
library.add(faFileArchive)

import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePdf)

import { faFileImage } from '@fortawesome/free-solid-svg-icons'
library.add(faFileImage)

import { faFileWord } from '@fortawesome/free-solid-svg-icons'
library.add(faFileWord)

import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
library.add(faFileExcel)

import { faFileCsv } from '@fortawesome/free-solid-svg-icons'
library.add(faFileCsv)

import { faFileCode } from '@fortawesome/free-solid-svg-icons'
library.add(faFileCode)

import { faFilePowerpoint } from '@fortawesome/free-solid-svg-icons'
library.add(faFilePowerpoint)

import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
library.add(faEllipsisH)

import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
library.add(faTimesCircle)

import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
library.add(faExclamationTriangle)

import { faBars } from '@fortawesome/free-solid-svg-icons'
library.add(faBars)

import { faMinus } from '@fortawesome/free-solid-svg-icons'
library.add(faMinus)

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common.Authorization = token
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
